module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "id": "svg__man",
      "viewBox": "0 0 500 500"
    }
  }, [_c('ellipse', {
    staticClass: "clothes",
    attrs: {
      "id": "body__man",
      "cx": "115",
      "cy": "500",
      "rx": "150",
      "ry": "200"
    }
  }), _c('path', {
    staticClass: "skin",
    attrs: {
      "id": "head__man",
      "d": "\n    M50,250\n    c0,-80 50,-150 120,-150\n    s120,50 120,150\n    c-10,80 -20,120 -100,150\n    C60,420 50,250 50,250\n  "
    }
  }), _c('path', {
    attrs: {
      "id": "ear",
      "d": "\n    M130,250\n    c-40,-10 -10,60 10,50\n  "
    }
  }), _c('g', {
    attrs: {
      "id": "g__eye_man"
    }
  }, [_c('ellipse', {
    attrs: {
      "id": "eye_w__man",
      "cx": "230",
      "cy": "205",
      "rx": "25",
      "ry": "27"
    }
  }), _c('ellipse', {
    attrs: {
      "id": "eye_ball__man",
      "cx": "238",
      "cy": "185",
      "rx": "5",
      "ry": "5"
    }
  })]), _c('g', {
    attrs: {
      "id": "g__nose_and_hand"
    }
  }, [_c('g', {
    attrs: {
      "id": "hand__man"
    }
  }, [_c('path', {
    staticClass: "skin",
    attrs: {
      "id": "finger",
      "d": "\n        M280,300\n        q7,-10 15,0\n        l0,50\n        l-15,0\n        z\n      "
    }
  }), _c('g', {
    attrs: {
      "id": "g__dig"
    }
  }, [_c('path', {
    staticClass: "skin",
    attrs: {
      "id": "palm__man",
      "d": "\n          M275,340 \n          q60,0 60,10\n          l-5,80\n          l-50,0 \n          l-10,-65\n          Q268,343 275,340\n          z\n        "
    }
  }), _c('path', {
    staticClass: "clothes",
    attrs: {
      "id": "sleeve",
      "d": "\n          M295,410\n          l40,0\n          l-5,100\n          l-55,0\n          l-5,-100\n          z\n        "
    }
  })])]), _c('path', {
    attrs: {
      "id": "blood",
      "d": "\n        M280,275\n        h15\n        v20\n        q-8,5 -15,-5\n        z\n      "
    }
  }), _c('path', {
    staticClass: "skin",
    attrs: {
      "id": "nose__man",
      "d": "\n      M280,250\n      q10,0 20,30\n      c5,0 10,20 0,20\n      l-30,0\n      q-10,-5 0,-20\n      z\n    "
    }
  })]), _c('path', {
    attrs: {
      "id": "hair__man",
      "d": "\n    M90,90\n    c100,-30 150,20 200,-20\n    c20,80 -50,120 -100,120\n    s-100,90 -150,60\n    C-30,190 50,100 90,90\n  "
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02937cdf"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/container/index/components/Cover/svg/Man/Man.vue
// module id = 55
// module chunks = 0